<template>
    <div class="customer-seas-wrap" v-loading="loading">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left page-filter_icons" v-if="selectedList && selectedList.length">
                <span
                    >已选中<i>{{ selectedList.length }}</i
                    >项</span
                ><i class="iconfont icon-guanbi_dise cursor" @click="handleRemoveCheckbox"></i>
                <div>
                    <i class="iconfont icon-a-shenling1" @click="handleClickApply(selectedList)">申领</i>
                    <i class="iconfont icon-fenpei" @click="handleClickAllocation(selectedList)">分配</i>
                    <i class="iconfont icon-qiehuan" @click="handleClickTransfer(selectedList)">转移</i>
                    <i class="iconfont icon-shanchu1" @click="handleClickDel(selectedList)">删除</i>
                </div>
            </div>
            <div class="page-filter_wrap_left" v-else>
                <template v-if="highSeasList.length > 1">
                    <el-select
                        v-model="searchForm.sea_id"
                        class="custom-select160 input_bold"
                        placeholder="请选择"
                        size="small"
                        @change="handleClickSeaChange"
                    >
                        <el-option v-for="item in highSeasList" :key="item.id" :label="item.seas_name" :value="item.id">
                        </el-option>
                    </el-select>
                </template>
                <el-input
                    v-model="searchForm.keyword"
                    class="filter-input"
                    clearable
                    placeholder="请输入您想搜索的内容"
                    @clear="handleClickSearch"
                    @keyup.enter.native="handleClickSearch"
                >
                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                </el-input>
                <ListAdvancedFiltering
                    :field_form="'customers'"
                    :field_list="fieldsList"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
            </div>
            <div class="page-filter_wrap_right" v-if="is_admin">
                <el-button type="primary" @click="handleClickAdd">新增客户</el-button>
            </div>
        </div>
        <div class="page-content">
            <p class="filter-count" v-if="filterCount && !selectedList.length">共{{ pagination.total }}条</p>
            <CustomVxeTable
                ref="tableRef"
                :class="{ 'custom-table': filterCount && !selectedList.length }"
                :customConfig="tableCustomConfig"
                :empty-render="{ name: 'NotData' }"
                :isShowToolBar="true"
                :pagination.sync="pagination"
                :reduceHeight="reduceHeight"
                :tableData="tableData"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
                @selection-change="selectionChange"
            >
                <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                <vxe-column field="name" title="客户名称" fixed="left" min-width="260" show-overflow>
                    <template #default="{ row }">
                        <el-tooltip effect="dark" placement="top" v-if="row.claim_status === 0">
                            <div slot="content">申领中：{{ (row.claim_user || []).map(item=> item.name).join("、") }}</div>
                            <i class="custom-tooltip-icon iconfont icon-shenling orange"></i>
                        </el-tooltip>
                        <span class="link-label" @click="handleClickCompanyDetail(row)">{{
                            row.name && row.name.value
                        }}</span>
                    </template>
                </vxe-column>
                <vxe-column
                    v-for="(field, index) in fieldsList"
                    :key="field.field_key"
                    :align="field.align ? 'right' : 'left'"
                    :header-align="field.align ? 'right' : 'left'"
                    :field="field.field_key"
                    show-overflow
                    :title="field.field_name"
                    :min-width="getFieldWidth(field.field_type)"
                >
                    <template #header>
                        <div class="table_field_label">
                            <span v-text="field.field_name"></span>
                        </div>
                    </template>
                    <template #default="{ row }">
                        <div v-if="field.field_type === 'customer_contact'">
                            <RelatedContacts
                                v-if="row[field.field_key] && row[field.field_key].length"
                                :contactInfos="row[field.field_key]"
                            />
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'contact'">
                            <div v-if="row[field.field_key].length">
                                <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                    <PersonnelCard :userId="item.id" v-if="item.id">
                                        <template slot="container">
                                            <img :src="item.avatar ? item.avatar : defaultImg" alt="" class="avatar" />
                                            <span class="name" v-text="item.name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'department'">
                            <div v-if="row[field.field_key].length">
                                <div v-for="item in row[field.field_key]">
                                    <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                        <span v-text="item.department_name"></span>
                                    </el-tooltip>
                                </div>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'radio'">
                            <span
                                v-if="row[field.field_key]"
                                :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                v-text="row[field.field_key]"
                            ></span>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'checkbox'">
                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                <template v-if="field.extend.tag_interaction">
                                    <span
                                        v-for="item in row[field.field_key].slice(0, 2)"
                                        :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                        v-text="item"
                                    >
                                    </span>
                                    <span class="is_tag_interaction">+{{ row[field.field_key].length }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ row[field.field_key].join(",") }} </span>
                                </template>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'checkbox_user_tag'">
                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                <span
                                    v-for="item in row[field.field_key]"
                                    class="is_tag_interaction"
                                    v-text="item.name"
                                >
                                </span>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'image'">
                            <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                <el-image
                                    :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                    :src="row[field.field_key][0].file_path"
                                    fit="cover"
                                >
                                </el-image>
                                <el-popover
                                    :visible-arrow="false"
                                    placement="bottom-start"
                                    popper-class="table_custom_image_popover"
                                    title=""
                                    trigger="hover"
                                    width="254"
                                >
                                    <div slot="reference">
                                        <span
                                            v-if="row[field.field_key].length > 1"
                                            class="image_count"
                                            v-text="`+${row[field.field_key].length - 1}`"
                                        ></span>
                                    </div>
                                    <ul class="image_list">
                                        <li
                                            v-for="(img, img_index) in row[field.field_key]"
                                            :key="img_index"
                                            class="image_item"
                                        >
                                            <el-image
                                                :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                                :src="img.file_path"
                                                fit="cover"
                                            >
                                            </el-image>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'file'">
                            <div v-if="row[field.field_key].length" class="custom_list_file_field_wrap">
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="456"
                                >
                                    <span slot="reference" class="link-label">
                                        {{ row[field.field_key][0].file_name
                                        }}{{ row[field.field_key].length > 1 ? row[field.field_key].length - 1 : "" }}
                                    </span>
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li v-for="file in row[field.field_key]" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'invoice'">
                            <div v-if="row[field.field_key].length" class="custom_list_file_field_wrap">
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="456"
                                >
                                    <span slot="reference" class="link-label">
                                        {{ row[field.field_key][0].purchaser_name
                                        }}{{ row[field.field_key].length > 1 ? row[field.field_key].length - 1 : "" }}
                                    </span>
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li v-for="file in row[field.field_key]" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.purchaser_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'relate_approve_form'"></div>
                        <div v-else-if="field.field_type === 'id_card'">
                            <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                <span v-text="row[field.field_key].value"></span>
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="380"
                                >
                                    <span slot="reference" class="handle_icon_wrap" style="margin-left: 10px">
                                        <i class="iconfont icon-shenfenzheng"></i>
                                    </span>
                                    <el-form size="small">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item v-if="row[field.field_key].name" label="姓名" prop="name">
                                                    <span v-text="row[field.field_key].name"></span>
                                                </el-form-item> </el-col
                                            ><br />
                                            <el-col :span="24">
                                                <el-form-item
                                                    v-if="row[field.field_key].birthday"
                                                    label="出生日期"
                                                    prop="birthday"
                                                >
                                                    <span v-text="row[field.field_key].birthday"></span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item
                                                    v-if="row[field.field_key].address"
                                                    label="家庭住址"
                                                    prop="name"
                                                >
                                                    <span v-text="row[field.field_key].address"></span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="身份证号" prop="value">
                                                    <span v-text="row[field.field_key].value"></span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <img
                                        alt=""
                                        class="ic_card_icon"
                                        src="https://download.hecoos.com/enlightv/2025-02/02d922ef5bd0a7ded22b965632d634ea.png"
                                    />
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'paying_teller'">
                            <div
                                v-if="row[field.field_key] && row[field.field_key].text"
                                class="custom_paying_teller_field_wrap"
                            >
                                <span v-text="row[field.field_key].text"></span>
                                <el-popover
                                    placement="bottom"
                                    popper-class="paying_teller_detail_popper"
                                    trigger="click"
                                    width="350"
                                >
                                    <span slot="reference" class="handle_icon_wrap">
                                        <i class="iconfont icon-zhanghu"></i>
                                    </span>
                                    <el-form class="custom_detail_form" label-position="top" size="small">
                                        <el-form-item label="账户类型" prop="account_type">
                                            <span
                                                v-text="
                                                    row[field.field_key].account_type === 1 ? '个人账户' : '对公账户'
                                                "
                                            ></span>
                                        </el-form-item>
                                        <el-form-item label="户名" prop="account_name">
                                            <span v-text="row[field.field_key].account_name"></span>
                                        </el-form-item>
                                        <el-form-item label="账号" prop="card_number">
                                            <span v-text="row[field.field_key].card_number"></span>
                                        </el-form-item>
                                        <el-form-item label="所属银行" prop="bank_name">
                                            <span v-text="row[field.field_key].bank_name"></span>
                                        </el-form-item>
                                        <el-form-item
                                            v-if="field.extend.bank_branch_is_show"
                                            label="银行支行"
                                            prop="bank_branch"
                                        >
                                            <span v-text="row[field.field_key].bank_branch"></span>
                                        </el-form-item>
                                    </el-form>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'table'"></div>
                        <div v-else-if="field.field_type === 'checkbox_approval'">--</div>
                        <span v-else v-text="row[field.field_key] ? row[field.field_key] : '--'"></span>
                    </template>
                </vxe-column>
                <vxe-column field="operate" width="125" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-tooltip effect="dark" content="编辑" placement="top" v-if="is_admin"
                                ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                            ></el-tooltip>
                            <el-tooltip effect="dark" content="分配" placement="top" v-if="is_admin"
                                ><i class="iconfont icon-fenpei" @click="handleClickAllocation(row, 'item')"></i
                            ></el-tooltip>
                            <el-dropdown placement="bottom-end" trigger="click">
                                <el-tooltip effect="dark" content="更多" placement="top"
                                    ><i class="iconfont el-icon-more"></i
                                ></el-tooltip>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleClickApply(row, 'item')">
                                        申领
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickTransfer(row, 'item')" v-if="is_admin">
                                        转移
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickShare(row, 'item')" v-if="is_admin">
                                        分享
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickDel(row, 'item')" v-if="is_admin">
                                        删除
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img">
                            <img
                                src="https://download.hecoos.com/enlightv/2025-09/904b1eff0ee89688f6d0725316c6cb39.png"
                                alt=""
                            />
                        </div>
                        <p class="empty_desc">暂无客户，可以选择新增客户添加</p>
                        <div style="margin-top: 32px">
                            <el-button size="small" type="primary" @click="handleClickAdd">新增客户</el-button>
                        </div>
                    </div>
                </template>
            </CustomVxeTable>
        </div>

        <el-dialog
            v-if="deleteCustomerDialog"
            :before-close="handledeleteCustomerDialogClose"
            :close-on-click-modal="false"
            :visible.sync="deleteCustomerDialog"
            class="custom-dialog custom-tooltip-confirm-dialog"
            title=""
            width="390px"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">您确定要删除吗？</p>
                    <p>删除后不可恢复，请谨慎操作！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handledeleteCustomerDialogClose">取消</el-button>
                <el-button type="danger" @click="handledeleteCustomerConfirm">删除</el-button>
            </span>
        </el-dialog>
        <CustomerAllocation
            v-if="allocationDialog"
            :allocationDialog.sync="allocationDialog"
            :sea_id="searchForm.sea_id"
            :selectedList.sync="selectedTableData"
            @updateCallback="handleUpdateCallback"
        />
        <CustomerTransfer
            v-if="transferDialog"
            :sea_id="searchForm.sea_id"
            :selectedList.sync="selectedTableData"
            :transferDialog.sync="transferDialog"
            @updateCallback="handleUpdateCallback"
        />
        <CustomerApply
            v-if="applyDialog"
            :applyDialog.sync="applyDialog"
            :selectedList.sync="selectedTableData"
            :sea_id="searchForm.sea_id"
            @updateCallback="handleUpdateCallback"
        />
        <CustomerAdd
            v-if="addDialogVisible"
            :addDialogVisible.sync="addDialogVisible"
            :editId="editId"
            :sea_id="searchForm.sea_id"
            addType="public"
            @operateSuccessCallback="handleUpdateCallback"
        />
        <ShareDialog
            v-if="shareDialog"
            :shareCustomerId="shareCustomerId"
            :shareCustomerName="shareCustomerName"
            :shareDialog.sync="shareDialog"
        />
        <!-- 从消息点击进来的 -->
        <el-dialog
            v-if="messageCustomerDialog"
            :before-close="handleMessageCustomerDialogClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            :visible.sync="messageCustomerDialog"
            class="custom-dialog custom-message-notice-dialog"
            :title="messageNoticeTitle"
            width="462px"
        >
            <ul class="message_notice_box">
                <li v-for="(row, rowIndex) in messageNoticeTableData" :key="rowIndex" @click="handleClickNoticeCompanyDetail(row)">
                    <p class="ellipsis">{{ row.name }}</p><span class="link-label">详情</span>
                </li>
            </ul>
        </el-dialog>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
    </div>
</template>
<script>
import { pagination } from "@/mixins";
import {
    GetCustomerPublicList,
    GetHighSeasManagementList,
    CustomerPublicDel,
    getFormFields,
    checkClaimNum,
    CustomerPopupList
} from "@/api";
import { tableDataFieldShow } from "@/utils";
import { getOSSData } from "@/utils/uploadOss";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import CustomerAllocation from "./component/customer_allocation.vue";
import CustomerTransfer from "./component/customer_transfer.vue";
import CustomerApply from "./component/customer_apply.vue";
import CustomerAdd from "./component/customer_add.vue";
import ShareDialog from "./component/share_dialog.vue";
import RelatedContacts from "@/components/pComponents/RelatedContacts.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";

export default {
    name: "CustomerHighSeas",
    components: {
        ListAdvancedFiltering,
        CustomVxeTable,
        CustomerAllocation,
        CustomerTransfer,
        CustomerApply,
        CustomerAdd,
        ShareDialog,
        RelatedContacts,
        PersonnelCard,
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            is_admin: false, // 公海管理员：增删改查、申领、分配、分享、转移操作，公海成员：查看、申领
            searchForm: {
                sea_id: "",
                keyword: "",
                type: 1,
            },
            highSeasList: [],
            filterForm: {
                content: [
                    {
                        label: "",
                        meet: 1,
                        value: "",
                        common: false,
                    },
                ],
            },
            fieldsList: [],
            tableData: [],
            selectedList: [], // 复选框选中
            editId: "", // 编辑客户
            addDialogVisible: false, // 添加、编辑
            allocationDialog: false, // 分配
            transferDialog: false, // 转移
            deleteId: "",
            deleteCustomerDialog: false, // 删除
            applyDialog: false, // 申领
            selectedTableData: [], // 弹框需要
            shareCustomerId: "", // 分享客户id
            shareCustomerName: "", // 分享客户名称
            shareDialog: false, // 分享
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            systemFilterFields: [],
            custom_filter: {},
            // 附件预览
            previewImgList: [],
            previewImgSrc: "",

            // 消息进来查看的客户
            messageCustomerDialog: false,
            messageNoticeTitle: "消息通知",
            messageNoticeTableData: []
        };
    },
    mixins: [pagination],
    computed: {
        filterCount() {
            const list = this.filterForm.content;
            return list.filter((item) => item.value).length;
        },
        reduceHeight() {
            return this.filterCount ? 200 : this.tableData.length ? 170 : 120;
        },
    },
    created() {
        this.getFieldList();
        if(this.$route.query && this.$route.query.customer_ids) {
            this.messageNoticeTitle = this.$route.query.title || "-"
            this.getMessageNoticeData()
        }
    },
    mounted() {},
    methods: {
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("highSeasListLocalStorage");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.searchForm = localStorageData.searchForm;
                this.pagination.pageNum = localStorageData.pagination.pageNum;
                this.pagination.pageSize = localStorageData.pagination.pageSize;
            }
            this.getHighSeasManagementList();
            localStorage.removeItem("highSeasListLocalStorage");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const data = {
                searchForm: this.searchForm,
                pagination: {
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                },
            };
            localStorage.setItem("highSeasListLocalStorage", JSON.stringify(data));
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        // 清空复选框选中
        handleRemoveCheckbox() {
            this.selectedList = [];
            this.$refs.tableRef.removeCheckboxRow();
        },
        // 处理操作之后
        handleUpdateCallback() {
            this.selectedList = [];
            this.getTableData();
        },
        handleClickAdd() {
            this.editId = "";
            this.addDialogVisible = true;
        },
        handleClickEdit({ id }) {
            this.editId = id;
            this.addDialogVisible = true;
        },
        // 查看公司详情
        handleClickCompanyDetail({ id, name }) {
            this.setLocalStorageFunction();
            this.$router.push({
                name: "CustomerHighSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name: name.value,
                    sea_id: this.searchForm.sea_id,
                },
            });
        },
        // 分配
        handleClickAllocation(list, type) {
            this.selectedTableData = type == "item" ? [list] : list;
            this.allocationDialog = true;
        },
        // 申领
        handleClickApply(list, type) {
            this.selectedTableData = type == "item" ? [list] : list;
            checkClaimNum({ sea_id: this.searchForm.sea_id, customer_ids: this.selectedTableData.map((item) => item.id) }).then(
                (res) => {
                    if (res.code === 200) {
                        this.applyDialog = true;
                    } else {
                    }
                }
            );
        },
        // 转移
        handleClickTransfer(list, type) {
            this.selectedTableData = type == "item" ? [list] : list;
            this.transferDialog = true;
        },
        // 分享
        handleClickShare(row) {
            this.shareCustomerId = row.id;
            this.shareCustomerName = row.name && row.name.value;
            this.shareDialog = true;
        },
        // 删除
        handleClickDel(data, type) {
            this.deleteId = type == "item" ? [data.id] : data.map((item) => item.id);
            this.deleteCustomerDialog = true;
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name || file.purchaser_name);
        },
        handledeleteCustomerDialogClose() {
            this.deleteId = "";
            this.deleteCustomerDialog = false;
        },
        handledeleteCustomerConfirm() {
            CustomerPublicDel({ customer_ids: this.deleteId }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.deleteCustomerDialog = false;
                    this.handleUpdateCallback();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 获取公海列表
        getHighSeasManagementList() {
            GetHighSeasManagementList().then((res) => {
                if (res.code === 200) {
                    this.highSeasList = res.data || [];
                    if (!this.searchForm.sea_id && this.highSeasList.length) {
                        this.searchForm.sea_id = this.highSeasList[0].id || "";
                        this.is_admin = this.highSeasList[0].is_admin || false;
                    }
                    this.getTableData();
                }
            });
        },
        // 公海池切换
        handleClickSeaChange(sea_id) {
            const sea_item = this.highSeasList.find((item) => item.id === sea_id);
            this.is_admin = sea_item ? sea_item.is_admin : false;
            this.handleClickSearch();
        },
        // 筛选
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.handleClickSearch();
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getFieldList() {
            getFormFields({
                field_form: "customers",
                // filter_field_type: ""
            }).then((res) => {
                if (res.code === 200) {
                    this.fieldsList = [];
                    res.data.forEach((field) => {
                        // this.calculateTableWidth(field, [field.field_name]);

                        if (field.field_type === "control") {
                        } else {
                            if (field.field_type === "image") {
                                field.table_width = "220";
                            } else if (field.field_type === "file") {
                                field.table_width = "260";
                            } else if (field.field_type === "table") {
                                field.table_width = "150";
                                if (field._child) {
                                    field._child.forEach((child) => {
                                        if (child.field_type === "image" || child.field_type === "file") {
                                            child.table_width = "320";
                                        } else {
                                            child.table_width = "160";
                                        }
                                    });
                                }
                            } else if (field.field_type === "number") {
                                field.table_width = "220";
                                field.field_name = field.extend.unit
                                    ? field.field_name + "（" + field.extend.unit + "）"
                                    : field.field_name;
                            } else if (field.field_type === "date_range") {
                                field.table_width = "300";
                            } else if (field.field_type === "invoice") {
                                field.table_width = "300";
                            } else {
                                field.table_width = "220";
                            }
                            if (field.field_key !== "name" && field.field_key !== "salesperson") {
                                this.fieldsList.push(field);
                            }
                        }
                    });
                    this.getLocalStorageFunction();
                }
            });
        },
        // 获取单独的一列文字
        getColumnText(fieldsList, tableList) {
            fieldsList.forEach((field, fieldIndex) => {
                let textData = [];
                textData.push(field.field_name);
                tableList.map((item, tableIndex) => {
                    if (item[field.field_key] && (field.field_type === "table" || field.field_type == "system_file")) {
                        textData.push(`查看${field.field_name}`);
                    } else if (item[field.field_key] && field.field_type === "radio") {
                        textData.push(item[field.field_key].text);
                    } else if (item[field.field_key] && field.field_type === "checkbox") {
                        if (field.extend && field.extend.tag_interaction) {
                            textData.push(
                                item[field.field_key] && item[field.field_key].text
                                    ? item[field.field_key].text.join(",空")
                                    : ""
                            );
                        } else {
                            textData.push(
                                item[field.field_key] && item[field.field_key].text
                                    ? item[field.field_key].text.join()
                                    : ""
                            );
                        }
                    } else if (item[field.field_key] && field.field_type === "cascader") {
                        textData.push(
                            item[field.field_key] && item[field.field_key].text ? item[field.field_key].text : ""
                        );
                    } else if (item[field.field_key] && field.field_type === "department") {
                        textData.push(
                            item[field.field_key] && item[field.field_key].length > 0
                                ? item[field.field_key].join(",空")
                                : ""
                        );
                    } else if (item[field.field_key] && field.field_type === "customer_contact") {
                        if (item[field.field_key].text && item[field.field_key].text.length == 1) {
                            textData.push(item[field.field_key].text[0].name);
                        } else if (item[field.field_key].text && item[field.field_key].text.length > 1) {
                            textData.push(
                                `${item[field.field_key].text[0].name} ，+ ${item[field.field_key].text.length}`
                            );
                        }
                    } else if (item[field.field_key] && field.field_type === "image") {
                        let arr = [];
                        let length = item[field.field_key].length > 3 ? 3 : item[field.field_key].length;
                        for (var i = 1; i <= length; i++) {
                            arr.push("空空空");
                        }
                        textData.push(arr.join("1"));
                    } else if (item[field.field_key] && field.field_type === "file") {
                        textData.push("空空空空空");
                    } else if (item[field.field_key] && field.field_type === "ID_card") {
                        textData.push(item[field.field_key].id_card + "空");
                    } else if (item[field.field_key] && field.field_type === "telephone") {
                        if (item[field.field_key].phone_type == "1") {
                            textData.push(
                                "（" + item[field.field_key].prefix + "）" + item[field.field_key].phone_number
                            );
                        } else if (item[field.field_key].phone_type == "2") {
                            textData.push(item[field.field_key].prefix + "-" + item[field.field_key].phone_number);
                        }
                    } else if (item[field.field_key] && field.field_type === "paying_teller") {
                        textData.push(item[field.field_key].card_number + "空");
                    } else if (item[field.field_key] && field.field_type === "relate_approve_form") {
                        item[field.field_key].map((map) => {
                            let str = `空${map.approval_title}（id：${map.approval_id}）`;
                            textData.push(str);
                        });
                    } else if (item[field.field_key] && field.field_type === "address") {
                        let str = "";
                        if (item[field.field_key] && item[field.field_key].text) {
                            str += `${item[field.field_key].address_text}`;
                        }
                        if (item[field.field_key] && item[field.field_key].detail_address) {
                            str += ` ${item[field.field_key].detail_address}`;
                        }
                        textData.push(str);
                    } else if (item[field.field_key] && field.field_type === "invoice") {
                        let str = "";
                        item[field.field_key].map((map) => {
                            str = `${str}空${map.title}${map.total_amount}`;
                        });
                        textData.push(str);
                    } else if (item[field.field_key] && field.field_type === "crm_project") {
                        textData.push(item[field.field_key].project_name);
                    } else if (item[field.field_key] && field.field_type === "crm_customer") {
                        textData.push(item[field.field_key].customer_name);
                    } else if (item[field.field_key] && field.field_type === "ship_status") {
                        textData.push("空空空空");
                    } else if (item[field.field_key] && field.field_type === "date_range") {
                        textData.push(
                            item[field.field_key] && item[field.field_key].value
                                ? item[field.field_key].value.join(" - ")
                                : ""
                        );
                    } else if (field.field_type === "money" || field.field_type === "computed_money") {
                        let unit = item[field.field_key]
                            ? item[field.field_key].unit === "￥"
                                ? "（CNY-人民币）"
                                : "（USD-美元）"
                            : "";
                        let str = item[field.field_key] ? item[field.field_key].text + unit : "";
                        textData.push(str);
                    } else {
                        textData.push(item[field.field_key]).value;
                    }
                });
                this.calculateTableWidth(field, textData);
            });
        },
        // 计算文本宽度
        calculateTableWidth(field, textData) {
            let widthData = [];
            textData.forEach((item, key) => {
                // 创建一个新的 span 元素
                const span = document.createElement("span");
                // 设置 span 元素的样式
                span.style.fontSize = "16px";
                // 设置 span 元素的内容
                span.textContent = item;
                // 将 span 元素添加到页面中
                document.body.appendChild(span);
                // 获取 span 元素的宽度
                const width = span.offsetWidth;

                widthData.push(width);
                // 从页面中删除 span 元素
                span.remove();
            });
            var max = Math.max(...widthData);
            max = max + 42;
            this.$set(field, "table_column_width", max > 300 ? 300 : max);
        },
        getFieldWidth(field_type) {
            if (field_type == "id_card" || field_type === "paying_teller" || field_type === "file") {
                return "210";
            } else if (field_type == "checkbox") {
                return "160";
            } else {
                return "150";
            }
        },
        getTableData() {
            this.loading = true;
            GetCustomerPublicList({
                sea_id: this.searchForm.sea_id,
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                custom_filter: this.custom_filter,
            })
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        // this.getColumnText(this.fieldsList, list);
                        this.tableData = data || [];
                        this.pagination.total = total;
                        tableDataFieldShow(this.fieldsList, this.tableData);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
         // 查看消息通知
         getMessageNoticeData() {
            const ids = this.$route.query && this.$route.query.customer_ids;
            CustomerPopupList({customer_ids: ids}).then(res=> {
                if(res.code === 200) {
                    this.messageNoticeTableData = res.data || [];
                    this.messageCustomerDialog = true;
                }
            })
        },
        // 消息关联的客户弹框关闭
        handleMessageCustomerDialogClose() {
            this.messageCustomerDialog = false;
        },
        // 查看消息通知客户详情
        handleClickNoticeCompanyDetail({ id, name }) {
            this.setLocalStorageFunction();
            this.$router.push({
                name: "CustomerHighSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name,
                    sea_id: this.searchForm.sea_id,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.customer-seas-wrap {
    padding: 16px;

    .custom-tooltip-icon {
        margin-right: 4px;
    }

    .filter-count {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .custom-table {
        ::v-deep {
            .vxe-table {
                margin-top: 8px;
            }
        }
    }
    .page-filter_wrap_left {
        .input_bold {
            .el-input__inner {
                color: #000000;
            }
        }
    }
}
.message_notice_box {
    padding: 0 16px;
    min-height: 152px;
    max-height: 380px;
    overflow-y: auto;
    li {
        width: 100%;
        height: 38px;
        padding: 0 8px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        p {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }
        &:hover {
            background-color: rgba(0, 0, 0, 0.04);
            p {
                color: rgba(51, 51, 51, 1);
            }
            .link-label {
                color: rgba(75, 162, 255, 1);
            }
        }
        &:active {
            .link-label {
                color: rgba(34, 121, 214, 1);
            }
        }
    }
}
</style>
<style lang="scss">
.custom-message-notice-dialog {
    .el-dialog__header {
        border-bottom: none;
    }
    .el-dialog__body {
        padding: 0 0 16px;
    }
}
.customer-seas-wrap {
    .page-filter_icons {
        padding-top: 4px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(102, 102, 102, 1);
        gap: 0;

        .bold-count {
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            margin: 0 2px;
        }

        .icon-guanbi_dise {
            color: rgba(191, 191, 191, 1);
            margin-left: 4px;
        }

        span {
            i {
                vertical-align: top;
                color: rgba(51, 51, 51, 1);
                margin: 0 2px;
            }
        }

        & > div {
            margin-left: 9px;
            position: relative;
            display: flex;

            &::before {
                content: "";
                position: absolute;
                left: -1px;
                top: 4px;
                width: 1px;
                height: 16px;
                opacity: 1;
                background: rgba(232, 232, 232, 1);
            }

            .iconfont {
                margin-left: 8px;
                font-size: 14px;
                height: 24px;
                padding: 0 8px;
                border-radius: 4px;
                color: rgba(102, 102, 102, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &::before {
                    margin-right: 4px;
                }

                &:hover {
                    color: rgba(51, 51, 51, 1);
                    background: rgba(0, 0, 0, 0.04);
                }

                &:active {
                    color: rgba(34, 121, 214, 1);
                    background: rgba(0, 0, 0, 0.04);
                }
            }
        }
    }
}

@import "@/styles/filter-form-wrap.scss";
</style>
